import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";
import { FacilityService } from "../../../shared/services/facility.service";

@Component({
	selector: "app-already-scanned-in",
	templateUrl: "./already-scanned-in.component.html",
	styleUrls: ["./already-scanned-in.component.css"],
})
export class AlreadyScannedInComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private gradelevelService: GradeLevelService,
		private dialogService: DialogService,
		private facilityService: FacilityService
	) {}

	report = {
		EntryDate: new Date(),
		FacilityID: 0,
		FacilityLocationID: 0,
		IncludeAbsentFromSchool: true,
		IncludeNoAlreadyInScan: true,
		GradeLevelID: 0,
		GroupID: 0,
		HomeroomID: 0,
		SortByID: "FirstName",
		SortDirectionID: "ASC",
		SchoolID: 0,
		ImageLogo: "",
	};

	SchoolSelectShowAllText: string = "All Schools";

	FacilityList: any = [];
	FacilityLocationList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	HomeroomList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "School",
			Desc: "School",
		},
		{
			ID: "Grade",
			Desc: "Grade Level",
		},
		{
			ID: "AttendanceStatus",
			Desc: "Attendance Status",
		},
		{
			ID: "ScanTime",
			Desc: "Scan Time",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 485;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		this.loadFacilityList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}
	onFacilityChange(value) {
		this.report.FacilityID = value;

		this.loadFacilityLocationList();
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadFacilityList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.FacilitySelectListByUser();
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				this.FacilityList.unshift({
					FacilityID: 0,
					FacilityName: "All Facilities",
				});

				this.onFacilityChange(this.FacilityList[0].FacilityID);
				// this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadFacilityLocationList() {
		var result = this.reportService.FacilityLocationGetListByFacility(this.report.FacilityID);
		result.subscribe(
			(response) => {
				this.FacilityLocationList = response;

				this.FacilityLocationList.unshift({
					FacilityLocationID: 0,
					FacilityLocationName: "All Locations",
				});

				this.report.FacilityLocationID = this.FacilityLocationList[0].FacilityLocationID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: EntryDate
		strParam += "," + moment(this.report.EntryDate).format("MM/DD/YYYY") + "|EntryDate";

		//Parameter 3: FacilityID
		strParam += "," + this.report.FacilityID + "|FacilityID";

		//Parameter 4: FacilityLocationID
		strParam += "," + this.report.FacilityLocationID + "|FacilityLocationID";

		//Parameter 5: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 6: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 7: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 8: IncludeAbsentFromSchool
		strParam += "," + (this.report.IncludeAbsentFromSchool == true ? "1" : "0") + "|IncludeAbsentFromSchool";

		//Parameter 9: IncludeNoAlreadyInScan
		strParam += "," + (this.report.IncludeNoAlreadyInScan == true ? "1" : "0") + "|IncludeNoAlreadyInScan";

		//Parameter 10: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 11: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 12: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 13: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
